export default {
  methods: {
    hasSetting(key) {
      const { systemSetting } = this.$store.state;
      return systemSetting[key] ? true : false;
    },
  },
}